export enum RefillTypes {
  BTC = 'bitcoin',
  WMZ = 'wmz',
  WMR = 'wmr',
  YANDEX = 'yandex',
  STEAM = 'steam',
  QIWI = 'qiwi',
  CARD = 'card',
}
